import React, { useState } from 'react';
import { useProject } from '../../contexts/ProjectContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown, FiFolder } = FiIcons;

const ProjectSelector = () => {
  const { currentProject, projects, selectProject } = useProject();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
      >
        <SafeIcon icon={FiFolder} className="w-4 h-4 text-slate-600" />
        <span className="text-sm font-medium text-slate-900">
          {currentProject ? `Current project: ${currentProject.project_name}` : 'No project selected'}
        </span>
        <SafeIcon icon={FiChevronDown} className="w-4 h-4 text-slate-600" />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-slate-200 py-2 z-10">
          <div className="px-3 py-2 text-xs font-medium text-slate-500 uppercase tracking-wide">
            Select Project
          </div>
          <div className="max-h-60 overflow-y-auto">
            {projects.length === 0 ? (
              <div className="px-4 py-3 text-sm text-slate-500">
                No projects available
              </div>
            ) : (
              projects.map((project) => (
                <button
                  key={project.id}
                  onClick={() => {
                    selectProject(project);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-4 py-3 hover:bg-slate-50 transition-colors ${
                    currentProject?.id === project.id ? 'bg-blue-50 border-r-2 border-blue-600' : ''
                  }`}
                >
                  <div className="font-medium text-slate-900">{project.project_name}</div>
                  <div className="text-sm text-slate-500">
                    {project.business_type && `${project.business_type} • `}
                    <span className={`inline-flex px-2 py-1 text-xs rounded-full ${
                      project.status === 'live' ? 'bg-green-100 text-green-800' :
                      project.status === 'building' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {project.status}
                    </span>
                  </div>
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectSelector;